export default {name:'环境',category:['建筑设计','室内'],content:{Indoor:{name:'室内'},no_humans:{name:'没有人'},'tile floor':{name:'瓷砖地板'},'wooden floor':{name:'木质地板'}}};